// @flow
import React, { Component } from 'react';
import { View } from 'react-native';
import I18n from '../../../../../../lib/i18n';
import Details from '../Details';

export default class ReferralPromotionDetails extends Component<Props> {
  componentDidMount() {
    this.props.verifyGodfather(this.props.godfatherExternalId);
  }

  getTitles = () => {
    const { bonus, confirmPlanType, priceEligibilityError, godfatherValidityError, isDiscount } = this.props;

    if (!!godfatherValidityError) {
      return { title: I18n.t('SignUp.ConfirmPlan.referralPromotion.invalid.title'), subtitle: godfatherValidityError };
    }
    if (priceEligibilityError) {
      return {
        title: I18n.t('SignUp.ConfirmPlan.referralPromotion.ineligible.title'),
        subtitle: I18n.t('SignUp.ConfirmPlan.referralPromotion.ineligible.detail', { bonus }),
      };
    }
    if (isDiscount) {
      return {
        title: I18n.t('SignUp.ConfirmPlan.referralPromotion.IsDiscount.title', { bonus }),
        subtitle: I18n.t('SignUp.ConfirmPlan.referralPromotion.IsDiscount.detail', { bonus }),
      };
    }

    return {
      title: I18n.t('SignUp.ConfirmPlan.referralPromotion.NoDiscount.title', { bonus }),
      subtitle: I18n.t(`SignUp.ConfirmPlan.referralPromotion.NoDiscount.detail.${confirmPlanType}`, { bonus }),
    };
  };

  render() {
    const { title, subtitle } = this.getTitles();

    return (
      <View>
        <Details
          icon="inviteFriendSidebarIcon"
          isInvalid={this.props.priceEligibilityError || !!this.props.godfatherValidityError}
          title={title}
          subtitle={subtitle}
          onDelete={this.props.onDelete}
        />
      </View>
    );
  }
}

type Props = {
  bonus: string,
  confirmPlanType: string,
  godfatherExternalId: ?string,
  godfatherValidityError: ?string,
  hasActiveOrSuspendedSubscriptions: boolean,
  isDiscount: boolean,
  onDelete: Function,
  priceEligibilityError: boolean,
  style?: any,
  verifyGodfather: Function,
};
